import { ElementType, Template, GlobalConfig } from "@/types/builder";

const generateId = (): string => {
  return Math.random().toString(36).substr(2, 9);
};

export const createTemplate4MobileNavigationPopup = (
  globalConfig: GlobalConfig
): Template => ({
  id: "mobile-navigation",
  name: "Mobile Navigation",
  industry: "template4",
  elements: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        backgroundColor: "#FFFFFF",
        borderRadius: "0",
        padding: "48px 16px 32px 16px",
        margin: "0",
        width: "100vw",
        maxWidth: "100vw",
        minWidth: "100vw",
        height: "100vh",
        minHeight: "100vh",
        position: "fixed",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        display: "flex",
        flexDirection: "column",
        zIndex: "9999",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      },
      children: [
        // Close button (X) in top-right
        {
          id: generateId(),
          type: "button" as ElementType,
          content: "✕",
          styles: {
            position: "absolute",
            top: "24px",
            right: "24px",
            width: "32px",
            height: "32px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            backgroundColor: "transparent",
            border: "none",
            fontSize: "24px",
            fontWeight: "400",
            color: "#333333",
            fontFamily: "Poppins, sans-serif",
          },
        },
        // Navigation links
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "column",
            gap: "32px",
            margin: "100px 0 0 0",
            alignItems: "center",
          },
          children: [
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Product",
              href: "#hero",
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: "500",
                lineHeight: "40px",
                textAlign: "center",
                margin: "0",
                color: "#333333",
                textDecoration: "none",
                padding: "8px 16px",
                borderRadius: "8px",
                transition: "all 0.2s",
              },
              hoverStyles: {
                backgroundColor: "#F5F5F5",
                color: "#37b4e1",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Ingredients",
              href: "#ingredients",
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: "500",
                lineHeight: "40px",
                textAlign: "center",
                margin: "0",
                color: "#333333",
                textDecoration: "none",
                padding: "8px 16px",
                borderRadius: "8px",
                transition: "all 0.2s",
              },
              hoverStyles: {
                backgroundColor: "#F5F5F5",
                color: "#37b4e1",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Reviews",
              href: "#testimonials",
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: "500",
                lineHeight: "40px",
                textAlign: "center",
                margin: "0",
                color: "#333333",
                textDecoration: "none",
                padding: "8px 16px",
                borderRadius: "8px",
                transition: "all 0.2s",
              },
              hoverStyles: {
                backgroundColor: "#F5F5F5",
                color: "#37b4e1",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "FAQ",
              href: "#faq",
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: "500",
                lineHeight: "40px",
                textAlign: "center",
                margin: "0",
                color: "#333333",
                textDecoration: "none",
                padding: "8px 16px",
                borderRadius: "8px",
                transition: "all 0.2s",
              },
              hoverStyles: {
                backgroundColor: "#F5F5F5",
                color: "#37b4e1",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "ORDER NOW",
              href: "#pricing",
              styles: {
                backgroundColor: "#FBBC04",
                color: "#000000",
                padding: "16px 32px",
                borderRadius: "16px",
                fontWeight: "700",
                fontSize: "18px",
                border: "none",
                cursor: "pointer",
                fontFamily: "Poppins, sans-serif",
                marginTop: "20px",
                width: "auto",
                alignSelf: "center",
                textDecoration: "none",
                textAlign: "center",
                transition: "all 0.2s",
                boxShadow: "0 4px 12px rgba(251, 188, 4, 0.3)",
              },
              hoverStyles: {
                backgroundColor: "#E6A600",
                transform: "translateY(-2px)",
                boxShadow: "0 6px 16px rgba(251, 188, 4, 0.4)",
              },
            },
          ],
        },
      ],
    },
  ],
});
